import { PiggyBank, TrendingUp, Calendar, Percent, Wallet, CreditCard, Building, HandCoins } from 'lucide-react';

const Products = () => {
    const depositProducts = [
        {
            icon: <Calendar className="w-8 h-8" />,
            title: 'Daily Deposit',
            description: 'Save small amounts daily and build substantial savings over time',
            features: ['Flexible daily contributions', 'Disciplined savings habit', 'Competitive interest rates'],
            eligibility: 'Open to all members'
        },
        {
            icon: <TrendingUp className="w-8 h-8" />,
            title: 'Recurring Deposit',
            description: 'Fixed monthly deposits with attractive returns on maturity',
            features: ['Monthly deposit flexibility', 'Guaranteed returns', 'Multiple tenure options'],
            eligibility: 'Minimum deposit: Rs. 500/month'
        },
        {
            icon: <Wallet className="w-8 h-8" />,
            title: 'Fixed Deposit',
            description: 'Lump sum deposit with guaranteed returns and higher interest rates',
            features: ['Higher interest rates', 'Fixed tenure options', 'Loan against FD available'],
            eligibility: 'Minimum deposit: Rs. 10,000'
        },
        {
            icon: <Percent className="w-8 h-8" />,
            title: 'Monthly Interest Scheme',
            description: 'Earn regular monthly income from your fixed deposit',
            features: ['Monthly interest payout', 'Stable income source', 'Principal protection'],
            eligibility: 'Minimum investment: Rs. 25,000'
        },
        {
            icon: <PiggyBank className="w-8 h-8" />,
            title: 'Saving Deposit',
            description: 'Flexible savings account with withdrawal facility and interest earnings',
            features: ['Anytime withdrawal', 'Interest on balance', 'No lock-in period'],
            eligibility: 'Open to all members'
        }
    ];

    const loanProducts = [
        {
            icon: <HandCoins className="w-8 h-8" />,
            title: 'Personal Loan',
            description: 'Unsecured loans for personal needs at affordable interest rates',
            features: ['Quick processing', 'Minimal documentation', 'Flexible repayment terms'],
            eligibility: 'For active members with good standing'
        },
        {
            icon: <CreditCard className="w-8 h-8" />,
            title: 'Loan Against Deposits',
            description: 'Overdraft facility against your fixed deposits',
            features: ['Up to 90% of FD value', 'Lower interest rates', 'No EMI - pay interest only'],
            eligibility: 'Must have active FD account'
        },
        {
            icon: <Building className="w-8 h-8" />,
            title: 'Business Loan',
            description: 'Working capital and business expansion loans for entrepreneurs',
            features: ['Higher loan amounts', 'Business-friendly terms', 'Support for local enterprises'],
            eligibility: 'Business proof and collateral may be required'
        }
    ];

    return (
        <section id="products" className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Products & Services</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Comprehensive financial solutions designed to meet diverse member needs
                    </p>
                </div>

                <div className="mb-16">
                    <h3 className="text-2xl font-bold text-amber-900 mb-8">Deposit Products</h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {depositProducts.map((product, index) => (
                            <div key={index} className="bg-amber-50 rounded-xl p-6 border border-amber-200 hover:shadow-lg transition-shadow">
                                <div className="text-amber-900 mb-4">{product.icon}</div>
                                <h4 className="text-xl font-bold text-gray-900 mb-3">{product.title}</h4>
                                <p className="text-sm text-gray-700 mb-4">{product.description}</p>
                                <div className="mb-4">
                                    <p className="text-xs font-semibold text-gray-800 mb-2">Key Features:</p>
                                    <ul className="space-y-1">
                                        {product.features.map((feature, idx) => (
                                            <li key={idx} className="text-xs text-gray-600 flex items-start">
                                                <span className="text-emerald-600 mr-2">•</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <p className="text-xs text-gray-500 italic">Eligibility: {product.eligibility}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div>
                    <h3 className="text-2xl font-bold text-amber-900 mb-8">Loan Products</h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {loanProducts.map((product, index) => (
                            <div key={index} className="bg-amber-50 rounded-xl p-6 border border-amber-200 hover:shadow-lg transition-shadow">
                                <div className="text-amber-900 mb-4">{product.icon}</div>
                                <h4 className="text-xl font-bold text-gray-900 mb-3">{product.title}</h4>
                                <p className="text-sm text-amber-900 mb-4">{product.description}</p>
                                <div className="mb-4">
                                    <p className="text-xs font-semibold text-gray-800 mb-2">Key Features:</p>
                                    <ul className="space-y-1">
                                        {product.features.map((feature, idx) => (
                                            <li key={idx} className="text-xs text-gray-600 flex items-start">
                                                <span className="text-sky-600 mr-2">•</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <p className="text-xs text-gray-500 italic">Eligibility: {product.eligibility}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Products;
